import { CART_LINE_PRICING_STATUS } from './Cart.constants'
import { PdpLPGCartLineItem } from './Cart.PdpLPGLineItem'
import { RefillCartLineItem } from './Cart.RefillLineItem'
import { RentalCartLineItem } from './Cart.RentalLineItem'

import type { CartLinePricingStatus, CartLineType } from './Cart.types'

enum CART_LINE_TYPE {
  RENTAL = 'Rent',
  REFILL = 'Refill',
  PDP_LPG = 'LPG',
}

const getCartLineType = (line: CartLineType) => {
  if (!line) return null

  const cartLineType = line.attributes?.find((attribute) => attribute?.key === '_purchase_type')?.value
  const pricingStatus = line.attributes?.find((attribute) => attribute?.key === '_pricing_status')?.value as CartLinePricingStatus
  const isStockholdingLPG = pricingStatus === CART_LINE_PRICING_STATUS.STOCKHOLDING

  if (cartLineType === CART_LINE_TYPE.RENTAL && !isStockholdingLPG) {
    return CART_LINE_TYPE.PDP_LPG
  }

  if (cartLineType === CART_LINE_TYPE.RENTAL && isStockholdingLPG) {
    return CART_LINE_TYPE.RENTAL
  }

  if (cartLineType === CART_LINE_TYPE.REFILL) {
    return CART_LINE_TYPE.REFILL
  }
}

export const CartLineItem = ({ line }: { line: CartLineType }) => {
  if (!line) return null

  const cartLineType = getCartLineType(line)

  switch (cartLineType) {
    case CART_LINE_TYPE.RENTAL:
      return <RentalCartLineItem line={line} />
    case CART_LINE_TYPE.REFILL:
      return <RefillCartLineItem line={line} />
    case CART_LINE_TYPE.PDP_LPG:
      return <PdpLPGCartLineItem line={line} />
    default:
      return null
  }
}
